import React from 'react';
import PropTypes from 'prop-types';

import { rules } from '../../../conf/password.conf';

import Rule from './Rule';
import WordingService from '../../../services/WordingService';

const CnilContainer = ({ cnilRules, cnilError }) => (
  <div>
    {cnilError && <Rule name='error' label={WordingService.getWording('errorMessage', cnilError)} status="error" /> }
    <div id="cnil-rules">
      {rules.map(rule => (
        <Rule key={rule.name} name={rule.name} label={rule.label} status={cnilRules[rule.name] ? 'validated' : 'pending'} />
      ))}
    </div>
  </div>
);

CnilContainer.defaultProps = {
  cnilError: null,
};

CnilContainer.propTypes = {
  /** Password validator rules state */
  cnilRules: PropTypes.shape({
    digits: PropTypes.bool,
    lowercase: PropTypes.bool,
    min: PropTypes.bool,
    result: PropTypes.bool,
    uppercase: PropTypes.bool,
    space: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
    ]),
    accentedChars: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
    ]),
    specialChars: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
    ]),
  }).isRequired,
  /** Password errors list state */
  cnilError: PropTypes.string,
};

export default CnilContainer;
